import { config } from '@/config/config'
/*
 * Pad a number with leading zeros in JavaScript
 */
const zeroPad = (num: number, places: number = 2) => {
  if (num == 0) return 0

  return String(num).padStart(places, '0')
}

const formatterCurrency = (locale = 'de', currency = 'EUR') => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
  })
}

const Replacer = (str: string) => {
  config.placeholder.forEach((value, key) => {
    // replace all keys with values
    str = str.replace(new RegExp(`\\${key}`, 'g'), value)
  })
  return str
}

export default {
  formatterCurrency,
  zeroPad,
}
export { Replacer }
